import { get, postAPI, putAPI, deleteAPI } from "../services/api.services";
import Swal from "sweetalert2";
const { defaultPage } = require('../Common/Constant');

export const attributeList = async({page=defaultPage.current_page, recPerPage=defaultPage.perPage, searchKeyword = "", parentID = 0}) => {
    let data = {
        parentID: parentID,
        page: page,
        recPerPage: recPerPage,
        q: searchKeyword
    }
    let res = await postAPI('/attribute/list', data)
    return res;
}

export const attributeDetails = async({payload}) => {
    let res = await get('/attribute/details/'+payload);
    return res;
}

export const attributeDelete = async({id}) => {
    return Swal.fire({
        text: 'Are you sure you want to delete?',
        confirmButtonText: 'Yes',
        showCancelButton: true,
    }).then(async (result) => {
        if (result.value) {
            let res = await deleteAPI('/attribute/delete/'+id)
            return Swal.fire({
                text:res.message,
                timer: 1500,
            }).then(() => {
                return res;
            })
        }
    })
}

export const attributeUpdateStatus = async({id, status}) => {
    return Swal.fire({
        text: 'Are you sure you want to update?',
        confirmButtonText: 'Yes',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
            let res = await putAPI('/attribute/update-status/'+id+'/'+status)
            return Swal.fire({
                text:res.message,
                timer: 1500,
            }).then(() => {
                return res;
            })
        }
      })
}

export const attributeCreate = async({payload}) => {
    let res = await postAPI('/attribute/add', payload)
    return Swal.fire({
        text:res.message,
        timer: 1500,
    }).then(() => {
        return res;
    })
}

export const attributeUpdate = async({payload}) => {
    let data = {
        parentID: payload.parentID,
        name: payload.name,
        imageURL: payload.imageURL,
        priority: payload.priority,
        status: payload.status
    }
    let res = await putAPI('/attribute/update/'+payload?.id, data)
    return res;
}

export const attributeCheckName = async({name, id = 0}) => {
    let data = {
        name: name,
        id: id
    }
    let res = await postAPI('/attribute/check-unique', data);
    return res;
}